import React, { useState } from 'react'
import './auth.css'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import logo from "../../assets/Aspom-Logo.png"
import { apiRequest } from '../../api'
import { useDispatch } from 'react-redux'
import { userLogin } from '../../state/userSlice'
import Loader from '../../components/loader/Loader'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const Auth = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [toggleTabs, setToggleTabs] = useState('login')
  const {
    register,
    handleSubmit,
    formState:{errors},
    getValues,
  } = useForm({
    mode: 'onChange'
  })

  const handleToggleTabs = (val)=>{
    setToggleTabs(val)
  }

  // SIGN UP FUNCTION
  const handleSignUpForm = async (data) => {
    setIsLoading(true)
    try {
      const response = await apiRequest({
        url: '/auth/signup',
        method: 'POST',
        data: data
      })

      if(response?.success){
        MySwal.fire({
          icon: 'success',
          title: response?.message,
          showConfirmButton: false,
          timer: 4000
        });

        setTimeout(() => {
          navigate(`/auth/verification/${response?.userId}`)
        }, 4000);
      }else{
        MySwal.fire({
          icon: 'error',
          title: 'Ooops',
          text: response?.message,
          showConfirmButton: false,
          timer: 5000
        });
      }
      
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
      MySwal.fire({
        icon: 'error',
        title: 'Ooops',
        text: "There's an error processing your request, Try again",
        showConfirmButton: false,
        timer: 5000
      });
    }
  }

  // LOGIN FUNCTION
  const handleLoginForm = async (data) => {
    setIsLoading(true)
    try {
      const response = await apiRequest({
        url: 'auth/login',
        method: 'POST',
        data: data
      })

      if(response?.success){
        MySwal.fire({
          icon: 'success',
          title: response?.message,
          showConfirmButton: false,
          timer: 2000
        });
        const newData = {token: response?.token, ...response?.user}
        setTimeout(() => {
          dispatch(userLogin(newData))
          navigate('/')
        }, 2000);
      }else{
        MySwal.fire({
          icon: 'error',
          text: response?.message,
          showConfirmButton: false,
          timer: 5000
        });
        if(response?.userId){
          setTimeout(() => {
            navigate(`/auth/verification/${response?.userId}`)
          }, 5000);
        }
      }
      
      setIsLoading(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
      MySwal.fire({
        icon: 'error',
        text: "There's an error processing your request, Try again",
        showConfirmButton: false,
        timer: 3000
      });
    }
  }
  return (
    <section className='login__page'>
      <div className="login__container">

          <div className="login__content">
            <div className="login__content-heading">
              <div className="login__content-text">
                <h1 className="login__form-title">
                  {toggleTabs === 'login' ? 'Login' : 'Signup'}
                </h1>
                <span className="login__form-subtitle">
                  {toggleTabs === 'login' ? 'Welcome back!' : ''}
                </span>
              </div>
              <img src={logo} alt="" className="login__content-logo" />
            </div>

            {/* TABS */}
            <div className="login__form-tabs">
              <button className={`login__form-tab ${
                toggleTabs === 'login' ? 'active' : ''
              }`} 
              onClick={()=>handleToggleTabs('login')}>Login</button>
              <button className={`login__form-tab ${
                toggleTabs === 'signup' ? 'active' : ''
              }`} 
              onClick={()=>handleToggleTabs('signup')}>Signup</button>
            </div>

            {/* LOGIN FORM */}
            {toggleTabs === 'login' && 
              <form className="login__form" 
              onSubmit={handleSubmit(handleLoginForm)}
              >
                <div className="login__form-data login">
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <i className='bx bx-group login__form-icon'></i>
                      <label htmlFor="email" className='login__form-label'>Staff ID</label>
                      <input type='text' 
                      name='staffId' 
                      className='login__form-input'
                      {...register('staffId',{required: 'This field is required'})}
                      />
                    </div>
                    {errors.staffId && <span className="login__form-error">
                      {errors.staffId.message}</span>}
                  </div>
                  
                  <div className='login__form-div'>
                    <i className='bx bx-lock-alt login__form-icon'></i>
                    <label htmlFor="email" className='login__form-label'>Password</label>
                    <input type='password' 
                    placeholder='*************' 
                    name='password' 
                    className='login__form-input'
                    {...register('password',{required: 'This field is required'})}
                    />
                    {errors.password && <span className="login__form-error">
                      {errors.password.message}</span>}
                  </div>
                </div>

                <Link to='/auth/forgot-password' className='login__form-link'>
                  Forgot password?
                </Link>
                {isLoading ? <Loader/> : <button
                type='submit'
                className='login__form-button'>Login</button>}
              </form>
            }

            {/* SIGN UP FORM */}
            {toggleTabs === 'signup' && 
              <form className="login__form" 
              onSubmit={handleSubmit(handleSignUpForm)}>
                <div className="login__form-data">
                  {/* FIRSTNAME */}
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <i className='bx bx-user login__form-icon'></i>
                      <label htmlFor="email" className='login__form-label'>Firstname</label>
                      <input type='text' 
                      name='email' 
                      className='login__form-input'
                      {...register('firstName',{required: 'This field is required'})}
                      />
                    </div>
                    {errors.firstName && <span className="login__form-error">
                      {errors.firstName.message}</span>}
                  </div>
                  {/* LASTNAME */}
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <i className='bx bx-user login__form-icon'></i>
                      <label htmlFor="email" className='login__form-label'>Lastname</label>
                      <input type='text' 
                      name='lastName' 
                      className='login__form-input'
                      {...register('lastName',{required: 'This field is required'})}
                      />
                    </div>
                    {errors.lastName && <span className="login__form-error">
                      {errors.lastName.message}</span>}
                  </div>
                  {/* STAFFID */}
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <i className='bx bx-group login__form-icon'></i>
                      <label htmlFor="email" className='login__form-label'>Staff ID</label>
                      <input type='text' 
                      name='staffId' 
                      className='login__form-input'
                      {...register('staffId',{required: 'This field is required'})}
                      />
                    </div>
                    {errors.staffId && <span className="login__form-error">
                      {errors.staffId.message}</span>}
                  </div>
                  {/* EMAIL */}
                  <div className='login__form-div'>
                    <i class='bx bx-envelope login__form-icon'></i>
                    <label htmlFor="email" className='login__form-label'>Email</label>
                    <input type='email' 
                    placeholder='example@email.com' 
                    name='email' 
                    className='login__form-input'
                    {...register('email',{required: 'This field is required'})}
                    />
                    {errors.email && <span className="login__form-error">
                      {errors.email.message}</span>}
                  </div>
                  {/* DEPARTMENT */}
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <label htmlFor="email" className='login__form-label'>Department</label>
                      <select name="department" id=""
                      className='login__form-input select'
                        {...register('department',{required: 'This field is required'})}>
                          <option value="" disabled>Select a department</option>
                          <option value="Account">Account</option>
                          <option value="Admin">Admin</option>
                          <option value="Compliance">Compliance</option>
                          <option value="IT">IT</option>
                          <option value="Sales">Sales</option>
                          <option value="Social Media">Social Media</option>
                          <option value="Ticket">Ticket</option>
                          <option value="Tour">Tour</option>
                          <option value="Visa">Visa</option>
                      </select>
                    </div>
                    {errors.department && <span className="login__form-error">
                      {errors.department.message}</span>}
                  </div>
                  {/* ROLE */}
                  <div className='login__form-div'>
                    <div className="login__form-field">
                      <label htmlFor="role" className='login__form-label'>Role</label>
                      <select name="role" id=""
                      className='login__form-input select'
                        {...register('role',{required: 'This field is required'})}>
                          <option value="" disabled>Select a role</option>
                          <option value="Officer">Officer</option>
                          <option value="Supervisor">Supervisor</option>
                      </select>
                    </div>
                    {errors.role && <span className="login__form-error">
                      {errors.role.message}</span>}
                  </div>
                  {/* PASSWORD */}
                  <div className='login__form-div'>
                    <i className='bx bx-lock-alt login__form-icon'></i>
                    <label htmlFor="password" className='login__form-label'>Password</label>
                    <input type='password' 
                    placeholder='*************' 
                    name='password' 
                    className='login__form-input'
                    {...register('password', {
                      required: 'This field is required',
                      minLength: {
                          value: 8,
                          message: 'Password must be at least 8 characters long'
                      },
                      validate: {
                          containsUppercase: value => /[A-Z]/.test(value) || 'Password must contain at least one uppercase letter',
                          containsLowercase: value => /[a-z]/.test(value) || 'Password must contain at least one lowercase letter',
                          containsNumber: value => /\d/.test(value) || 'Password must contain at least one number'
                      }
                      })}
                    />
                    {errors.password && <span className="login__form-error">
                      {errors.password.message}</span>}
                  </div>
                  {/* CONFIRM PASSWORD */}
                  <div className='login__form-div'>
                    <i className='bx bx-lock-alt login__form-icon'></i>
                    <label htmlFor="email" className='login__form-label'>Confirm Password</label>
                    <input type='password' 
                    placeholder='*************' 
                    name='cpassword' 
                    className='login__form-input'
                    {...register('cpassword',{
                      validate: (value)=>{
                        const {password} = getValues()
                        if(value !== password){
                          return 'Password not match'
                        }
                      }
                    })}
                    />
                    {errors.cpassword && <span className="login__form-error">
                      {errors.cpassword.message}</span>}
                  </div>
                </div>
                {isLoading ? <Loader/> : <button
                type='submit'
                className='login__form-button'>Proceed</button>}
                
              </form>
            }

          </div>
      </div>
    </section>
  )
}

export default Auth